import { INN_MASK, PHONE_MASK, PHONE_PLACEHOLDER } from "@/consts";
import { useDataFormStore } from "@/stores/form";
import { getNameOrganization } from "@/utils/getDataForm";
import { limitInput } from "@/utils/handleChangeForm";
import { inject } from 'vue';

export default {
    props: {
        isCargoPickup: {
            type: Boolean,
            default: false,
        }
    },

    setup(props) {

        const dataForm = useDataFormStore();
        const cityFromRestrictions = inject('cityFromRestrictions');

        const citiesArr = inject('citiesArr', [])
        const options = [
            {
                value: "Стандарт",
                label: "Стандарт",
            },
            {
                value: "Цилиндры",
                label: "Цилиндры",
            },
            {
                value: "Шины",
                label: "Шины",
            },
        ];

        function hanlerCityFrom(city) {
            // if ((dataForm.sender.cityFrom === "Челябинск" ||
            // dataForm.sender.cityFrom === "Екатеринбург")) {
            //   dataForm.applicationTimeIsOver = '15:00'
            // }
            // else if(dataForm.applicationTimeIsOver === '15:00') {
            //   dataForm.applicationTimeIsOver = '13:00'
            // }
           if (props.isCargoPickup) {
                const selectedFullInfoCity = citiesArr.value.find(({name}) => name === city)
                cityFromRestrictions.value = {
                name: selectedFullInfoCity.name,
                maxAcceptedShippingHeight: selectedFullInfoCity.maxAcceptedShippingHeight,
                maxAcceptedShippingWeight: selectedFullInfoCity.maxAcceptedShippingWeight,
                maxAcceptedShippingSize: selectedFullInfoCity.maxAcceptedShippingSize,
                };
           } 

           dataForm.updateApplicationTimeIsOver();
        }

        return {
            dataForm,
            citiesArr,
            options,
            PHONE_MASK,
            INN_MASK,
            PHONE_PLACEHOLDER,
            limitInput,
            getNameOrganization,
            hanlerCityFrom,
            disableIdenticalCity: function (value) {
                if (value === dataForm.consignee.cityTo) {
                    return true
                }

                return false
            },

            checkPhone: function () {
                if (dataForm.consignee.phoneConsignee === dataForm.sender.phoneSender) {
                    dataForm.sender.emailSender = dataForm.consignee.emailConsignee
                    dataForm.sender.firstNameSender = dataForm.consignee.firstNameConsignee
                    dataForm.sender.secondNameSender = dataForm.consignee.secondNameConsignee
                    dataForm.sender.surnameSender = dataForm.consignee.surnameConsignee
                    dataForm.sender.innSender = dataForm.consignee.innConsignee
                    dataForm.sender.name = dataForm.consignee.name
                }
            },
        };
    },
};
